import axios from 'axios';
import * as yup from 'yup';
const responseSchema = yup
    .object()
    .required()
    .shape({
    message: yup.string().required(),
    data: yup.object().camelCase().shape({
        id: yup.string().required(),
        email: yup.string().required(),
        firstname: yup.string().required(),
        lastname: yup.string().required(),
        piid: yup.string().required(),
        avatar: yup.string().nullable().defined(),
        practiceId: yup.string().required(),
        practiceName: yup.string().nullable(),
        cpoDashboardAccess: yup.boolean().nullable()
    }),
});
export async function currentUserRequest(options = {}) {
    const { cancelToken } = options;
    const response = await axios.get('/api/auth/currentUser', {
        cancelToken,
    });
    const { data } = await responseSchema.validate(response.data);
    return data;
}
